import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import App from './App.tsx';
import { SubscriptionProvider } from './contexts/SubscriptionContext.tsx';
import './index.css';

// PostHog configuration with fallbacks
const postHogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY || import.meta.env.REACT_APP_PUBLIC_POSTHOG_KEY || '';
const postHogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || import.meta.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com';

// Debug logging
console.log('[PostHog Init] Key available:', !!postHogKey);
console.log('[PostHog Init] Host:', postHogHost);

const options = {
  api_host: postHogHost,
};

// App component wrapper with subscription context
const AppContent = () => (
  <BrowserRouter>
    <SubscriptionProvider>
      <App />
    </SubscriptionProvider>
  </BrowserRouter>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {postHogKey ? (
      <PostHogProvider apiKey={postHogKey} options={options}>
        <AppContent />
      </PostHogProvider>
    ) : (
      <AppContent />
    )}
  </React.StrictMode>
); 